import {
    ADMINGETWALLETTRANSACTIONLISTBYID_SUCCESS,
    ADMINGETWALLETTRANSACTIONLISTBYID_FAILED,
    RESET_GETWALLETTRANSACTIONLISTBYIDADMIN,
    LOADING_GETWALLETTRANSACTIONLISTBYIDADMIN,
    NETWORK_ERROR_GETWALLETTRANSACTIONLISTBYIDADMIN,
} from "../types/index";
import { partnerServices } from "../../config/axios";


function resetGetWalletTransByIdAdmin() {
    return {
        type: RESET_GETWALLETTRANSACTIONLISTBYIDADMIN,
    };
}

const getWalletTransactionListByIdAdmin =
    (userData, authTokenIs) => async (dispatch) => {
        dispatch({ type: LOADING_GETWALLETTRANSACTIONLISTBYIDADMIN });
        await partnerServices
            .post("getWalletTransactionListById", userData, { headers: { AuthToken: authTokenIs } })
            .then((res) => {
                switch (res.data.status) {
                    case "success":
                        dispatch(getWalletTransactionListByIdAdminSuccess(res.data));
                        break;
                    default:
                        dispatch(getWalletTransactionListByIdFailedAdmin(res.data));
                        break;
                }
            })
            .catch((err) => {
                dispatch({
                    type: NETWORK_ERROR_GETWALLETTRANSACTIONLISTBYIDADMIN,
                    payload: err
                });
            });
    };
function getWalletTransactionListByIdAdminSuccess(data) {
    return {
        type: ADMINGETWALLETTRANSACTIONLISTBYID_SUCCESS,
        payload: data
    };
}
function getWalletTransactionListByIdFailedAdmin(data) {
    return {
        type: ADMINGETWALLETTRANSACTIONLISTBYID_FAILED,
        payload: data
    };
}

export { getWalletTransactionListByIdAdmin, resetGetWalletTransByIdAdmin };
